<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :has-lock="hasLock"
            :document-lock="documentLock"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :lockable="lockable"
            @force-takeover="attemptTakeover"
            @takeover="takeOver"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :seo-data="data ? data.latest_seo : null"

            model="App\Models\TableTemplate"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            class="mt-2"
            :error="errors.name ? errors.name[0] : null"
        />
        <p class="my-1 text-xs text-gray-600 mb-3">The name is for internal use only</p>

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 mb-3">The note is for internal use only</p>

        <div class="mt-3">
            <rocket-table
                :language="form.language"
                v-model="form.table"
                :errors="errors.table ? errors.table[0] : null"
            />
        </div>

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
import contentBlocksForm from "../mixins/contentBlocksForm";

export default {
    mixins: [crudForm, contentBlocksForm],
    name: "TableTemplateForm",
    data() {
        return {
            form: {
                name: this.getFormData("name"),
                editor_note: this.getFormData("editor_note"),
                table: this.getFormData("table", this.defaultTableData()),
                language_id: this.getFormData("language_id"),
            },
        };
    },
    mounted() {
        if (this.languageData) {
            this.form.language_id = this.languageData.id;
        }
    },
};
</script>
